import { render, staticRenderFns } from "./dialogRule.vue?vue&type=template&id=87a0b9ee&"
import script from "./dialogRule.vue?vue&type=script&lang=js&"
export * from "./dialogRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports